import React, { useState } from "react";
import StarryNightSky from "./Stars";
const Faqsec = () => {
  const FAQSEC = [
    {
      displayText:
        "Why call vendors in Odisha or Chhattisgarh for rates when Coaler shows pan-India prices?",
      descText:
        "Save time and costs – view live rates from CIL subsidiaries, private miners, and auction winners nationwide, secured by blockchain.",
    },
    {
      displayText: "How does Coaler handle state-specific GST and permits?",
      descText:
        "Our platform auto-generates GST-compliant invoices and alerts transporters about regional permit requirements via smart contracts. ",
    },
    {
      displayText: "Can I buy coal from recent government auctions via Coaler?",
      descText:
        "Yes! Vendors who win coal blocks via auctions can list inventory directly on the platform.",
    },
    {
      displayText:
        "Are coal quality certifications (GCV, ash content) verified?”",
      descText:
        "Sellers must upload third-party lab reports – tamper-proof via blockchain integration. ",
    },
    {
      displayText: "Do you support rail transport logistics?",
      descText:
        "Soon! We’re partnering with Indian Railways for seamless rail-coal bookings. ",
    },

    {
      displayText:
        "Is Coaler suitable for large enterprises or small-scale buyers?",
      descText:
        "Coaler is designed for all—from large industrial firms to small business owners, ensuring seamless coal sourcing and logistics for every scale of operation. ",
    },
    {
      displayText: "What’s the COALER Coin and how do I use it?",
      descText:
        "COALER Coin is our native cryptocurrency – earn it through transactions or referrals, and redeem it for discounts, priority listings, or faster support. ",
    },
    {
      displayText: "How does blockchain benefit me as a user?",
      descText:
        "Blockchain ensures secure payments, tamper-proof quality checks, and real-time tracking, making every transaction reliable and transparent.",
    },
  ];
  const [isClicked, setisClicked] = useState([0]);
  return (
    <>
      <section className="relative w-full flex justify-center bg-black text-white">
        <StarryNightSky height="100vh" />
        <div className="flex flex-col md:flex-row gap-8 md:gap-[90px] my-8 md:my-14 px-4 md:px-0">
          {/* FAQ Title */}
          <div className="md:max-w-64 w-full flex lg:justify-center md:justify-start">
            <h1 className="font-bold text-6xl md:text-9xl">FAQ</h1>
          </div>

          {/* Questions Section */}
          <div className="max-w-full md:max-w-[627px] flex flex-col gap-3 w-full">
            {FAQSEC.map((item, i) => (
              <div
                key={i}
                className={`flex flex-col px-4 md:px-6 py-3 rounded-[8px] ${
                  (i + 1) % 2 === 1
                    ? "bg-white/10 backdrop-blur-[300px]"
                    : "bg-[#6969691A] backdrop-blur-[300px]"
                }`}
              >
                <div className="flex justify-between items-start">
                  <div className="font-bold cursor-pointer text-sm md:text-base leading-tight md:leading-[100%] pr-4">
                    {item.displayText}
                  </div>
                  <button
                    className="w-6 h-6 min-w-[24px] mt-1"
                    onClick={() => {
                      if (isClicked.includes(i)) {
                        setisClicked(isClicked.filter((index) => index !== i));
                      } else {
                        setisClicked([...isClicked, i]);
                      }
                      console.log(isClicked);
                    }}
                  >
                    {isClicked.includes(i) ? (
                      <img src="uparrow.png" alt="" />
                    ) : (
                      <img src="downarrow.png" alt="" />
                    )}
                  </button>
                </div>
                {isClicked.includes(i) && (
                  <div className="mt-3 font-normal text-[16px] leading-[100%] tracking-[0em] ">
                    {item.descText}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Faqsec;
